export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinatario:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utente non trovato"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contatti"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dettagli"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selezione utenti"])}
}